var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 401,
    viewBox: "0 0 502 401",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0.5L501.276 401H0.723816L250 0.5Z",
    fill: "url(#paint0_linear_3_280)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.609 116.983C181.081 115.596 182.836 115.17 183.891 116.188L473.655 395.841C475.597 397.715 474.27 401 471.572 401H88.1893C86.1339 401 84.6872 398.98 85.3491 397.034L180.609 116.983Z",
    fill: "url(#paint1_linear_3_280)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M277.214 211.895C278.553 210.262 281.116 210.488 282.149 212.33L385.493 396.532C386.615 398.532 385.17 401 382.877 401H128.343C125.81 401 124.417 398.055 126.025 396.097L277.214 211.895Z",
    fill: "url(#paint2_linear_3_280)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M218.608 285.274C218.781 282.951 221.42 281.703 223.326 283.043L383.248 395.546C385.644 397.232 384.451 401 381.522 401H213.231C211.487 401 210.11 399.517 210.24 397.777L218.608 285.274Z",
    fill: "url(#paint3_linear_3_280)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_280",
    x1: 251,
    y1: -1.52884e-7,
    x2: 268,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#546E7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#37474F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_280",
    x1: 182.5,
    y1: 114,
    x2: 281.5,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78909C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546E7A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3_280",
    x1: 277.5,
    y1: 215.5,
    x2: 255,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78909C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3_280",
    x1: 220.5,
    y1: 287.5,
    x2: 300.5,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0BEC5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.13313e01ca570e954454f1703d8490ea.svg";
export { ForwardRef as ReactComponent };